document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('shape-theme-request-container');
  if (!container) return;

  const textarea = container.querySelector('#shape-theme-request');
  const SPECIAL_OPTION = 'Logo or Character (Special)';

  function getSelectedShape() {
    const select = document.querySelector('variant-selects select[name*="option"]');
    return select ? select.value : null;
  }

  function toggle() {
    const selected = getSelectedShape();
    const show = selected === SPECIAL_OPTION;

    container.classList.toggle('hidden', !show);
    container.setAttribute('aria-hidden', String(!show));
    if (textarea) textarea.toggleAttribute('required', show);
  }

  toggle(); // initial

  // Native <select> change
  document.querySelectorAll('variant-selects select[name*="option"]').forEach(s => {
    s.addEventListener('change', toggle);
  });

  // Dawn custom event (button picker)
  document.querySelectorAll('variant-selects, variant-radios').forEach(el => {
    el.addEventListener('variant:change', toggle);
  });
});